var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button",on:{"click":_vm.mute}},[_c('div',{staticClass:"supel"},[(_vm.chat.muted)?_c('MuteIcon'):_c('SpeakerIcon')],1),_vm._v(" "+_vm._s(_vm.chat.muted ? _vm.$t("messenger.no_sound") : _vm.$t("messenger.with_sound"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }